/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Sv } from './Sv';

class PaperTemplate extends Sv {
    constructor() {
        super();
        this.baseUrl += '/paperTemplate';
    }

    data({ templateName, certId, schoolOrgId, currentPage, pageSize } = {}) {
        return super.get('/data', {
            templateName,
            certId,
            schoolOrgId,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, certId, templateName, passMark, examTime, templateConfig, questionNum, totalScore, schoolOrgId } = {}) {
        return super.post('/save', {
            id,
            certId,
            templateName,
            passMark,
            examTime,
            templateConfig,
            questionNum,
            totalScore,
            schoolOrgId,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }
}

export default new PaperTemplate();
export { PaperTemplate };
